/* ============================================
   NEW JOURNAL CAROUSEL FUNCTIONALITY
   ============================================ */

(function() {
    'use strict';

    const journalCarousels = document.querySelectorAll('.journal-carousel');
    if (journalCarousels.length === 0) return;

    // Initialize each journal carousel
    journalCarousels.forEach((journalCarousel) => {
        const carousel = journalCarousel.querySelector('.journal-carousel__carousel');
        const track = journalCarousel.querySelector('.journal-carousel__track');
        const items = journalCarousel.querySelectorAll('.journal-carousel__item');
        const prevButton = journalCarousel.querySelector('.journal-carousel__arrow--prev');
        const nextButton = journalCarousel.querySelector('.journal-carousel__arrow--next');
        const progressBar = journalCarousel.querySelector('.journal-carousel__progress-bar');
        const progressLine = journalCarousel.querySelector('.journal-carousel__progress-line');

        if (!carousel || !track || items.length === 0) return;

        initCarousel(journalCarousel, carousel, track, items, prevButton, nextButton, progressBar, progressLine);
    });

    function initCarousel(journalCarousel, carousel, track, items, prevButton, nextButton, progressBar, progressLine) {
        let currentIndex = 0;
        let itemsPerView = 2; // Mobile: 2 items
        let totalSlides = 0;
        let maxIndex = 0;
        let touchStartX = 0;
        let touchEndX = 0;

        // Update items per view based on screen size
        function updateItemsPerView() {
            if (window.innerWidth >= 992) {
                itemsPerView = 4; // Desktop: 4 items
            } else {
                itemsPerView = 2; // Mobile/Tablet: 2 items
            }

            const totalItems = items.length;
            totalSlides = Math.ceil(totalItems / itemsPerView);
            maxIndex = Math.max(0, totalSlides - 1);
        }

        function getTrackGap() {
            const computedStyles = window.getComputedStyle(track);
            const gap = parseFloat(computedStyles.columnGap || computedStyles.gap || '0');
            return Number.isNaN(gap) ? 0 : gap;
        }

        function updateItemWidths() {
            const carouselWidth = carousel.offsetWidth;
            if (!carouselWidth) return;

            const gap = getTrackGap();
            const itemWidth = (carouselWidth - (gap * (itemsPerView - 1))) / itemsPerView;
            const safeItemWidth = itemWidth > 0 ? itemWidth : carouselWidth / itemsPerView;

            items.forEach((item) => {
                item.style.flexBasis = `${safeItemWidth}px`;
                item.style.maxWidth = `${safeItemWidth}px`;
                item.style.width = `${safeItemWidth}px`;
            });
        }

        // Update carousel position
        function updateCarousel() {
            updateItemWidths();
            const gap = getTrackGap();

            if (items.length <= itemsPerView) {
                track.style.transform = 'translateX(0)';
                return;
            }

            const carouselWidth = carousel.offsetWidth;
            const pageStep = carouselWidth + gap;
            const translateX = -(currentIndex * pageStep);

            track.style.transform = `translateX(${translateX}px)`;
        }

        // Update progress bar
        function updateProgress() {
            if (totalSlides === 0) return;

            const progress = ((currentIndex + 1) / totalSlides) * 100;
            if (progressBar) {
                progressBar.style.width = `${progress}%`;
            }
            if (progressLine) {
                progressLine.style.width = `${progress}%`;
            }
        }

        // Navigate carousel
        function navigateCarousel(direction) {
            const newIndex = currentIndex + direction;

            if (newIndex < 0) {
                currentIndex = 0;
            } else if (newIndex > maxIndex) {
                currentIndex = maxIndex;
            } else {
                currentIndex = newIndex;
            }

            updateCarousel();
            updateProgress();
            updateButtons();
        }

        // Update button states
        function updateButtons() {
            if (prevButton) {
                prevButton.disabled = currentIndex === 0;
            }

            if (nextButton) {
                nextButton.disabled = currentIndex >= maxIndex || items.length <= itemsPerView;
            }
        }

        // Touch/swipe handlers
        function handleTouchStart(e) {
            touchStartX = e.changedTouches[0].screenX;
        }

        function handleTouchEnd(e) {
            touchEndX = e.changedTouches[0].screenX;
            handleSwipe();
        }

        function handleSwipe() {
            const swipeThreshold = 50; // Minimum distance for a swipe
            const diff = touchStartX - touchEndX;

            if (Math.abs(diff) > swipeThreshold) {
                if (diff > 0) {
                    // Swipe left - next slide
                    navigateCarousel(1);
                } else {
                    // Swipe right - previous slide
                    navigateCarousel(-1);
                }
            }
        }

        // Initialize this carousel
        updateItemsPerView();
        updateCarousel();
        updateProgress();
        updateButtons();

        // Set up event listeners
        if (prevButton) {
            prevButton.addEventListener('click', () => navigateCarousel(-1));
        }

        if (nextButton) {
            nextButton.addEventListener('click', () => navigateCarousel(1));
        }

        // Touch/swipe support
        carousel.addEventListener('touchstart', handleTouchStart, { passive: true });
        carousel.addEventListener('touchend', handleTouchEnd, { passive: true });

        // Handle window resize
        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                updateItemsPerView();
                updateCarousel();
                updateProgress();
                updateButtons();
            }, 250);
        });
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            // Already initialized above, but ensure it runs after DOM is ready
        });
    }
})();
